import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const PAGE_SIZES = [25, 50, 100];
export const DEFAULT_SIZE = 50;

export const usePager = (resetKey) => {
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(DEFAULT_SIZE);
  useEffect(() => { setPage(1); }, [resetKey, size]);
  return { page, size, setPage, setSize };
};

export const usePaged = (rows, resetKey) => {
  const pager = usePager(resetKey);
  const pages = Math.max(1, Math.ceil(rows.length / pager.size));
  const page = Math.min(pager.page, pages);
  return { ...pager, page, total: rows.length, items: rows.slice((page - 1) * pager.size, page * pager.size) };
};

const NavBtn = ({ onClick, disabled, label, testId, children }) => (
  <button type="button" onClick={onClick} disabled={disabled} aria-label={label} data-testid={testId}
    className="h-8 w-8 grid place-items-center rounded-md border border-[#E5E7EB] bg-white hover:border-[#E60000] hover:text-[#E60000] disabled:opacity-40 disabled:hover:border-[#E5E7EB] disabled:hover:text-inherit transition-colors">{children}</button>
);

export const Pager = ({ page, size, total, setPage, setSize, testId = "pager" }) => {
  const pages = Math.max(1, Math.ceil(total / size));
  useEffect(() => {
    if (page > pages) { setPage(pages); }
  }, [page, pages, setPage]);
  if (!total) return null;
  const from = (page - 1) * size + 1;
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 px-3 py-2.5 text-xs text-gray-600 border-t bg-white" data-testid={testId}>
      <span data-testid={`${testId}-range`}>Showing {from}–{Math.min(page * size, total)} of {total}</span>
      <div className="flex items-center gap-2">
        <label className="flex items-center gap-1.5">Rows
          <select value={size} onChange={(e) => setSize(Number(e.target.value))} className="h-8 rounded-md border border-[#E5E7EB] bg-white px-1.5" data-testid={`${testId}-size`}>
            {PAGE_SIZES.map((n) => <option key={n} value={n}>{n}</option>)}
          </select>
        </label>
        <NavBtn onClick={() => setPage(page - 1)} disabled={page <= 1} label="Previous page" testId={`${testId}-prev`}><ChevronLeft className="w-4 h-4" /></NavBtn>
        <span className="min-w-[70px] text-center" data-testid={`${testId}-page`}>Page {page} of {pages}</span>
        <NavBtn onClick={() => setPage(page + 1)} disabled={page >= pages} label="Next page" testId={`${testId}-next`}><ChevronRight className="w-4 h-4" /></NavBtn>
      </div>
    </div>
  );
};
